import { Button, type ButtonProps, type ButtonVariant } from '@/components/ui/button'

export type ToggleButtonProps = ButtonProps & {
  pressed?: boolean
  pressedVariant?: ButtonVariant | null
}

function ToggleButton({
  pressed = false,
  variant = 'outline',
  pressedVariant = 'selection',
  role,
  ...props
}: ToggleButtonProps) {
  return (
    <Button
      {...props}
      role={role}
      variant={pressed ? pressedVariant : variant}
      data-slot="toggle-button"
      data-state={pressed ? 'on' : 'off'}
      aria-pressed={role === 'radio' ? undefined : pressed}
    />
  )
}

export { ToggleButton }
